package com.xtream.data_kmp.db.repo

 import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.PagingSource
import androidx.room3.RoomRawQuery
import androidx.room3.Transaction
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.FavoriteVodStreamEntity
import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.db.dao.BaseRoomStreamsInterface
import com.xtream.data_kmp.db.dao.MovieSortBy
import com.xtream.data_kmp.db.dao.RoomBaseInterface
import com.xtream.data_kmp.db.tables.StreamType
import com.xtream.data_kmp.db.tables.VodCategoryWithVisibleStatus
import com.xtream.data_kmp.db.tables.toHiddenCategoryEntity
import com.xtream.data_kmp.dto.TrendingMovie
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodStream
import kotlinx.coroutines.flow.Flow


class VodStreamsRepository (
val db: AppRoomDB
): LocalStreamsRepository<VodStream, FavoriteVodStreamEntity, VodCategory>(
    db.vodDao() as BaseRoomStreamsInterface<VodStream>,
    db.vodFavoritesDao() as RoomBaseInterface<FavoriteVodStreamEntity>,
    db.vodCategoriesDao() as RoomBaseInterface<VodCategory>
){

    fun getStreamsFlow(categoryId:Int?=null, nameQuery:String?=null, limit: Int?=-1) : Flow<List<Any>?> {

        return when (categoryId) {
            AllConst.FAV_CATEGORIES_ID.toInt() -> getFavoritesAsFlow(limit)
            AllConst.WATCHED_CATEGORIES_ID.toInt() ->db.vodDao().getWatchedStreamsAsIntermediateFlow(limit)// getWatchedStreamsFlow(limit)
            else -> getStreamsAsFlow(categoryId = categoryId,limit=limit)
        }
    }

    fun  getPagedCategoriesWithStreams()= db.vodCategoriesDao().getPagingCategoriesWithSize()
    suspend fun all(categoryId:Int?=AllConst.ALL_CATEGORIES_ID.toInt(), nameQuery:String?="",limit: Int?=15, offset: Int?=0): List<Any> {
       return when (categoryId) {
            AllConst.FAV_CATEGORIES_ID.toInt() -> db.vodDao().getFavoriteStreams(limit)
            AllConst.WATCHED_CATEGORIES_ID.toInt() -> db.vodDao().getWatchedStreamsAsIntermediate(limit)
            else -> db.vodDao().all(categoryId=categoryId,nameQuery=nameQuery, limit=limit, offset=offset)
        }
    }
    fun getRecommendationsList(categoryId:Int?,limit: Int,         excludeIds: List<Int?>? = null
    ): Flow<List<VodStream>> = db.vodDao().getRecommendationsList(categoryId,limit, excludeIds)

    suspend fun getVodByStreamId(id: Int?): VodStream? = db.vodDao().getStreamById(id)

    fun topAsFlow(limit:Int = AllConst.ROOM_TOP_QUERY_LIMIT) = db.vodDao().topAsFlow(limit)

     suspend fun getVodByIcons(titles:List<String>,icons: List<String>?): List<VodStream>{
      /*   val query = RoomRawQuery(
             sql = """SELECT * FROM vodTable WHERE """ + icons?.joinToString(" OR ") { "streamIcon LIKE '%$it%'" },
         )*/
         val titleSql = titles.joinToString(" OR ") { "name LIKE '${it}' " }
         val iconSql = icons?.joinToString(" OR ") { "streamIcon LIKE '%${it}%'" }
         val where = listOfNotNull(titleSql, iconSql).joinToString(" OR ")

         val query =RoomRawQuery( """
        SELECT * FROM vodTable
        WHERE $where
        GROUP BY name, streamIcon 
    """)


       //   Log.d("Trednding", query.sql)
         return db.vodDao().getVodByIcons(query)
     }


    @Transaction
     suspend fun refreshTrending(newList: List<TrendingMovie>?){
    db.vodDao().deleteTrending()
        if (newList == null) return
    db.vodDao().insertTrending(newList)


}

    fun getTrendingAsFlow() = db.vodDao().trendingAsFlow()

    fun getStreamsAsPagingSource(
        categoryIds: List<Int>?,
        searchQuery: String?,
        sortBy: MovieSortBy,
        yearRange: IntRange? = null
    ): PagingSource<Int, VodStream> = db.vodDao().allAsPagingSource(categoryIds, searchQuery, sortBy,yearRange)

    fun getPagedVodStreamsFlow(categoryIds: List<Int>?,
                               keyWord: String?,
                               sortBy: MovieSortBy,
                               yearRange: IntRange? = null
                               ): Flow<PagingData<VodStream>> = Pager<Int, VodStream>(
        config = PagingConfig(
            pageSize = PAGING_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {
            when  {
                categoryIds.isNullOrEmpty() -> getStreamsAsPagingSource(null, keyWord, sortBy, yearRange)
                categoryIds.firstOrNull() ==AllConst.FAV_CATEGORIES_ID.toInt() -> getFavoritesPagingSource()
                else ->   getStreamsAsPagingSource(categoryIds, keyWord, sortBy, yearRange)

            }
        }
    ).flow



    fun getCategoriesWithVisibleStatus():
            Flow<List<VodCategoryWithVisibleStatus>> {

        return db.vodCategoriesDao().getCategoriesWithVisibleStatus()

    }

    suspend fun toggleLiveCategory(category: VodCategory){

        val hiddenCategory= category.toHiddenCategoryEntity(StreamType.MOVIE)
        with(db.hiddenCategoryDao()) {
            val isHidden =  isHidden(category.categoryId, StreamType.MOVIE)
            if (isHidden)
                unhideCategory(hiddenCategory)
            else
                hideCategory(hiddenCategory)
        }



    }

}